import { API } from "../../Services";

export const partnersComissionList = (partnerId,query='') =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_PARTNER_COMISSION_LIST",
        })
    
        API.partnersComissionList(partnerId,query).then((res)=>{
            console.log(res);
            let data = JSON.parse(JSON.stringify(res))?.data?.commissions
            console.log(data);
          
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_PARTNER_COMISSION_LIST",
                    payload:{data:data,totalRecords:res.data.totalRecords},
                })
            },1000)
        }).catch((err)=>{
            let data = JSON.parse(JSON.stringify(err?.message))
            dispatch({
                type:"ERROR_PARTNER_COMISSION_LIST",
                payload:data,
            })
        })
    }
}

